import classNames from 'classnames';
import classes from 'components/generics/flows/LoginSignUpFlow/SignUpFlow/components/SignUp/components/SignUpForm/index.module.scss';
import { SIGN_UP_FIELDS } from 'components/generics/flows/LoginSignUpFlow/SignUpFlow/components/SignUp/utils';
import { useSignUp } from 'components/generics/flows/LoginSignUpFlow/SignUpFlow/context';
import DateInput from 'components/generics/inputs/DateInput';
import EmailInput from 'components/generics/inputs/EmailInput';
import FullNameInput from 'components/generics/inputs/FullNameInput';
import PhoneInput from 'components/generics/inputs/PhoneInput';
import React, { HTMLAttributes } from 'react';

interface Props extends HTMLAttributes<HTMLDivElement> {
  fields?: SIGN_UP_FIELDS[];
}

const getRelevantFields = (fields?: SIGN_UP_FIELDS[]) => {
  const fieldsToShow: { [key in any]: any } = {};
  for (const field of Object.values(SIGN_UP_FIELDS)) {
    fieldsToShow[field] = !fields || fields.indexOf(field) > -1;
  }
  return fieldsToShow;
};

const SignUpForm = ({ fields, ...props }: Props) => {
  const fieldsToShow = getRelevantFields(fields);
  const {
    email,
    phoneNumber,
    fullName,
    dateOfBirthErrorMessage,
    dateOfBirth,
    fieldChangeHandler,
  } = useSignUp();

  return (
    <div {...props}>
      {fieldsToShow[SIGN_UP_FIELDS.EMAIL] && (
        <EmailInput
          label="Email Address"
          name={'Email'}
          className={classes.inputContainer}
          inputClassName={classes.baseInput}
          value={email}
          placeholderClass={classes.placeholder}
          onChange={fieldChangeHandler?.(SIGN_UP_FIELDS.EMAIL)}
          withPlaceHolderTransition={false}
        />
      )}
      {fieldsToShow[SIGN_UP_FIELDS.PHONE_NUMBER] && (
        <PhoneInput
          name={'PhoneNumber'}
          label="Phone Number"
          value={phoneNumber}
          onChange={fieldChangeHandler(SIGN_UP_FIELDS.PHONE_NUMBER)}
        />
      )}
      {fieldsToShow[SIGN_UP_FIELDS.FULL_NAME] && (
        <FullNameInput
          label="Full Name"
          name={'FullName'}
          className={classes.inputContainer}
          placeholderClass={classes.placeholder}
          inputClassName={classes.baseInput}
          value={fullName}
          onChange={fieldChangeHandler(SIGN_UP_FIELDS.FULL_NAME)}
          withPlaceHolderTransition={false}
        />
      )}
      {fieldsToShow[SIGN_UP_FIELDS.DATE_OF_BIRTH] && (
        <DateInput
          label="Birthday"
          name={'Date'}
          className={classes.inputContainer}
          placeholderClass={classes.placeholder}
          inputClassName={classNames(classes.baseInput, classes.noMargin)}
          value={dateOfBirth}
          onChange={fieldChangeHandler(SIGN_UP_FIELDS.DATE_OF_BIRTH)}
          errorMessage={dateOfBirthErrorMessage}
          withPlaceHolderTransition={false}
        />
      )}
    </div>
  );
};

export default SignUpForm;
